import api from ".";

export const obterEquipeById = async (id) => {
    try {
        const { data } = await api.get("equipe/equipeById", {
            params: { id },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const retornaEquipesPorTipo = async (empresaId, plantaoTipoId, ativo) => {
    try {
        const { data } = await api.get("/serviceEquipePorTipo", {
            params: { empresaId, plantaoTipoId, ativo },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const integrantes = async (novoColaborador) => api.post(`equipe/integrantes`, novoColaborador);

export const retornaIntegrantes = async (equipeId) => {
    try {
        const { data } = await api.get("equipe/retornaIntegrantes", {
            params: { equipeId },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
/**
 *
 * @param {*} obj { start, size, filters, filtersMode, globalFilter, sorting, equipeId }
 * @returns data
 */
export const listarIntegrantes = async ({ start, size, filters, filtersMode, globalFilter, sorting, equipeId }) => {
    if (!equipeId) {
        return [];
    }
    try {
        const { data } = await api.get("equipe/listarIntegrantes", {
            params: { start, size, filters, filtersMode, globalFilter, sorting, equipeId },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
